// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3Gxh5","modalForm":"UpgradeEpcsModal_modalForm__1V6mJ","modalFooter":"UpgradeEpcsModal_modalFooter__EK5YK"};